import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=39e591da&scoped=true&"
import script from "./NumberView.vue?vue&type=script&lang=js&"
export * from "./NumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e591da",
  null
  
)

export default component.exports